import React from 'react';
import PropTypes from 'prop-types';

import OENumberInput from '../../controls/oe-number-input';
import {OEObjectModelValueTypes} from '../oe-object-model-value-edit-model';
import OEObjectModelValueCell from './oe-object-model-value-cell';

export default class OEObjectModelNumberValueCell extends React.PureComponent {

    constructor(props) {
        super(props);

        this.onChange = this.onChange.bind(this);
    }

    render()    {
        return (
            <OEObjectModelValueCell {...this.props}>
                <OENumberInput
                    disabled={this.props.disabled}
                    allowUndefined={this.props.allowUndefined}
                    deferMinMaxConstraint={this.props.deferMinMaxConstraint}
                    min={this.props.min}
                    max={this.props.max}
                    step={this.props.type === OEObjectModelValueTypes.integer ? 1 : this.props.step}
                    value={this.props.value}
                    onChange={this.onChange}
                />
            </OEObjectModelValueCell>
        );
    }

    onChange(sender, value)    {
        if(value === this.props.value) return;
        if(this.props.onChange)   this.props.onChange(this, this.props.name, value);
    }
};

OEObjectModelNumberValueCell.defaultProps = Object.assign({
    disabled:                   false,
    allowUndefined:             true,
    deferMinMaxConstraint:      true
}, OEObjectModelValueCell.defaultProps);

OEObjectModelNumberValueCell.propTypes = Object.assign({
    disabled:                   PropTypes.bool,
    allowUndefined:             PropTypes.bool,
    deferMinMaxConstraint:      PropTypes.bool,
    min:                        PropTypes.number,
    max:                        PropTypes.number,
    step:                       PropTypes.number,
    value:                      PropTypes.number,
}, OEObjectModelValueCell.propTypes);